module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-50.edd665b9.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-50.png
// module id = 3340
// module chunks = 11